// NPM Imports
import { cloneDeep } from "lodash";

// Internal Imports
import { DASHBOARD } from "../../constants";
import { GlobalUtils } from "../../utils";

// Destructuring
const { numberForamting } = GlobalUtils;

const { DASHBOARD_DOC_STATUS, DASHBOARD_DOC_TYPES } = DASHBOARD;

export const filterObjFromArray = (array, key, filter) =>
  array.filter(arr => arr[key] === filter);

// Get the dashboard pipeline document's data for dashboard doc status
export const dashboardPipelineDoc = (documents, dealCounts, docTypesMap) => {
  let dashboardDocSt = [];
  dashboardDocSt = DASHBOARD_DOC_STATUS.map(docSt => {
    const docData = { ...docSt };
    documents.forEach(doc => {
      const dealValue = filterObjFromArray(dealCounts, "name", doc.name)[0];
      if (doc.name === docSt.status) {
        docData.dealValue = dealValue ? dealValue.value : 0;
        docData.frequency = doc.frequency;
      }
    });
    if (docTypesMap[docSt.status]) {
      docData.types = docTypesMap[docSt.status];
    } else {
      docData.types = cloneDeep(DASHBOARD_DOC_TYPES);
    }
    return docData;
  });
  return dashboardDocSt;
};

// Get the dashboard document types data for dashboard doc status & pie chart
export const dashboardDocTypes = docTypes => {
  let dDocTypes = [];
  dDocTypes = DASHBOARD_DOC_TYPES.map(docType => {
    const dtype = { ...docType };
    docTypes.forEach(type => {
      if (type.name === docType.name) {
        dtype.frequency = type.frequency;
      }
    });
    return dtype;
  });
  return dDocTypes;
};

export const dashboardDocTypesByStatus = docTypes => {
  const docTypesObj = {};
  docTypes.forEach((docType, index) => {
    if (index <= 10) {
      let tempTypesArr = [];
      if (docTypesObj[docType.status]) {
        tempTypesArr = docTypesObj[docType.status];
      } else {
        tempTypesArr = cloneDeep(DASHBOARD_DOC_TYPES);
      }
      tempTypesArr.forEach(type => {
        if (type.name === docType.name) {
          type.frequency = docType.frequency;
        }
      });
      docTypesObj[docType.status] = tempTypesArr;
    }
  });
  return docTypesObj;
};

// Get the won/Lost deals Data (in array of objects format) for deal performance table
export const getWonLostDealsData = (wonDeals, lostDeals) => {
  let avgDiscountPer = 0;
  if (wonDeals && wonDeals.total_value !== 0) {
    avgDiscountPer = (wonDeals.total_discount / wonDeals.total_value) * 100;
  }

  let avgDealCLoseTime = 0;
  if (wonDeals && wonDeals.total_close_days !== 0) {
    avgDealCLoseTime = Math.ceil(
      wonDeals.total_close_days / (24 * 60) / wonDeals.frequency,
    );
  }

  const wonLostDeals = [
    {
      icon: "thumbs-up",
      col: [
        {
          className: "dealperformance-table-col-textwrapper",
          colorClassName: "primary-color",
          title: "Client Approved",
          value: wonDeals ? wonDeals.frequency : 0,
        },
        {
          className: "dealperformance-table-col-textwrapper",
          colorClassName: "primary-color",
          title: "Net Value",
          value: wonDeals ? numberForamting(wonDeals.net_value, "$") : 0,
        },
      ],
    },
    {
      icon: "percent",
      col: [
        {
          className: "dealperformance-table-col-textwrapper",
          colorClassName: "high-danger-color",
          title: "Avg. Discount",
          value: `${avgDiscountPer.toFixed(2)}%`,
        },
        {
          className: "dealperformance-table-col-textwrapper",
          colorClassName: "high-danger-color",
          title: "Discount Value",
          value: wonDeals ? numberForamting(wonDeals.total_discount, "$") : 0,
        },
      ],
    },
    {
      icon: "thumbs-down",
      col: [
        {
          className: "dealperformance-table-col-textwrapper",
          colorClassName: "defaults-color",
          title: "Client Rejected",
          value: lostDeals ? lostDeals.frequency : 0,
        },
        {
          className: "dealperformance-table-col-textwrapper",
          colorClassName: "defaults-color",
          title: "Net Value",
          value: lostDeals ? numberForamting(lostDeals.net_value, "$") : 0,
        },
      ],
    },
    {
      icon: "clock",
      col: [
        {
          className:
            "dealperformance-table-col-textwrapper last-table-textwrapper",
          colorClassName: "defaults-color",
          title: "Avg. deal close time",
          value: `${avgDealCLoseTime} Day${avgDealCLoseTime > 2 ? "s" : ""}`,
        },
      ],
    },
  ];

  return wonLostDeals;
};



// WEBPACK FOOTER //
// ./src/actions/DashboardActions/dashboardMethods.js